module.exports = __webpack_public_path__ + "static/img/slider-1.ff2bb48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-1.jpg
// module id = ZZtB
// module chunks = 1